/*
 * Bakeyy24 (blr-price) / Bakeyy Super (India Wholesale) checkout gate.
 *
 * Both tags carry a ₹2,500 minimum order on the discounted cart total.
 *
 * snippets/bakeyy24-status.liquid renders the cart status server-side with a
 * data-bakeyy24-eligible flag, and the theme re-renders it on every cart change.
 * This script only mirrors that flag onto the checkout controls and refuses the
 * checkout submit while the discounted cart total is under the minimum.
 *
 * It also honours [data-blr-cart-blocked] (snippets/bakeyy-blr-cart-status.liquid):
 * while the cart holds Bangalore-only products the viewer may not buy, checkout
 * is disabled for everyone, tagged or not.
 */
(() => {
  const STATUS = '[data-bakeyy24-cart-status]';
  const BLR_BLOCK = '[data-blr-cart-blocked]';   // snippets/bakeyy-blr-cart-status.liquid: Bangalore-only items the viewer cannot buy
  const CHECKOUT = 'button[name="checkout"]';
  const EXPRESS = '.additional-checkout-buttons, .hdt-cart__dynamic-checkout-buttons';
  let timer = null;

  const PENDING_GIVE_UP_MS = 8000;
  let pendingSince = 0;

  // Eligible by total, but are the discount codes actually on the cart yet?
  // (assets/bakeyy-cart-discounts.js attaches them and stamps data-tag-codes-applied when confirmed.)
  function codesPending(status) {
    const marker = document.querySelector('[data-tag-codes]');
    if (!marker || Number(marker.dataset.tagCodesThreshold || 0) <= 0) return false;
    if (marker.dataset.tagCodesApplied === 'true') return false;
    if (!pendingSince) pendingSince = Date.now();
    if (Date.now() - pendingSince > PENDING_GIVE_UP_MS) return false;   // don't strand the customer if Shopify rejects a code
    return true;
  }

  function applyBlrBlock() {
    document.querySelectorAll('cart-drawer, main-cart, form[action*="/cart"]').forEach((scope) => {
      const blocked = Boolean(scope.querySelector(BLR_BLOCK));
      scope.querySelectorAll(CHECKOUT).forEach((button) => {
        button.classList.toggle('is-blr-blocked', blocked);
        if (blocked) {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
        } else if (button.classList.contains('was-blr-blocked')) {
          button.disabled = false;
          button.removeAttribute('aria-disabled');
        }
        button.classList.toggle('was-blr-blocked', blocked);
      });
      scope.querySelectorAll(EXPRESS).forEach((element) => { if (blocked) element.hidden = true; });
    });
    // Checkout buttons that live outside a cart element (e.g. sticky bars)
    if (document.querySelector(BLR_BLOCK)) {
      document.querySelectorAll(CHECKOUT).forEach((button) => {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('is-blr-blocked', 'was-blr-blocked');
      });
    }
  }

  function apply() {
    applyBlrBlock();
    const blrBlocked = Boolean(document.querySelector(BLR_BLOCK));
    document.querySelectorAll(STATUS).forEach((status) => {
      const eligible = status.dataset.bakeyy24Eligible === 'true';
      const pending = eligible && codesPending(status);
      if (!pending) pendingSince = 0;
      const ready = eligible && !pending;
      const scope = status.closest('cart-drawer, main-cart') || document;
      status.classList.toggle('is-pending', pending);
      const subtext = status.querySelector('.bakeyy24-cart-status__copy span');
      if (pending && subtext) subtext.textContent = `Applying your ${status.dataset.bakeyy24Brand || 'Bakeyy24'} discount…`;
      scope.querySelectorAll(CHECKOUT).forEach((button) => {
        button.disabled = !ready || blrBlocked;
        button.setAttribute('aria-disabled', String(!ready || blrBlocked));
        button.classList.toggle('is-bakeyy24-blocked', !eligible);
        button.classList.toggle('is-bakeyy24-pending', pending);
      });
      scope.querySelectorAll(EXPRESS).forEach((element) => {
        element.hidden = !ready || blrBlocked;
      });
      if (pending) schedule(500);   // re-check until the codes are confirmed (or we give up)
    });
  }

  function schedule(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(apply, delay || 60);
  }

  // Hard stop: even if a button gets re-enabled elsewhere, never submit to checkout while ineligible.
  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    const blrBlock = document.querySelector(BLR_BLOCK);
    if (blrBlock) {
      event.preventDefault();
      event.stopImmediatePropagation();
      blrBlock.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      return;
    }
    const status = document.querySelector(STATUS);
    if (!status || (status.dataset.bakeyy24Eligible === 'true' && !status.classList.contains('is-pending'))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    status.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    status.classList.add('is-nudged');
    window.setTimeout(() => status.classList.remove('is-nudged'), 700);
  }, true);

  ['cart:update', 'cart:reload', 'cart:refresh', 'cart:discount-applied', 'bakeyy:codes-synced'].forEach((name) => {
    document.addEventListener(name, () => schedule(120));
  });

  const observer = new MutationObserver(() => schedule(60));
  const start = () => {
    observer.observe(document.body, { childList: true, subtree: true });
    apply();
  };
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start, { once: true });
})();
